
<template>
  <div class="apply_box">
    <div class="header"
         v-if="orderList.length>0">
      <div class="loanMoney">{{orderList[0].title}}</div>
      <p class="title">{{orderList[0].rightTitle}}</p>
    </div>
    <div class="pro_detail">
      <div class="pro_item">
        <h1 class="h1"><span class="line"></span> {{bigJson.title}} </h1>
      </div>
      <div class="pro_item"
           v-for="(item,index) in bigList"
           :key="index">
        <p>{{item.title}}</p>
        <p>{{item.rightTitle}}</p>
      </div>
    </div>
    <div class="bg"></div>
    <div class="pro_detail">
      <!-- <div class="pro_item1">
        <input type="text"
               placeholder="请输入验证码"
               class="left inputStyle">
        <span v-if="!cutStart"
              class="replace_btn right"
              @click="getMsgCode">获取验证码</span>
        <span v-else
              class="replace_btn right">{{second}}s</span>
      </div> -->
    </div>
    <div class="loan_btn"
         @click="sureRepay">确认还款</div>
  </div>
</template>

<script>
export default {
  components: {
  },
  data () {
    return {
      second: 59,
      cutStart: false,
      orderId: '',
      orderList: [],
      bigList: [],
      bigJson: {
        title: ''
      },
      sureReplayTop: [],
    }
  },
  mounted () {
    this.orderId = this.$route.query.orderId;
    this.util.title('还款');
    this.getDetails()
  },
  methods: {
    getDetails () {
      let param = {
        orderId: this.orderId,
        type: '1'
      }
      let _this = this;
      this.$get('/app/api/v1/rpyment/view', param)
        .then(res => {
          var e = res;
          if (e.code == 200) {
            e.data.appOrderCells.map(function (item) {
              if (item.type == "sureReplayTop") {
                _this.orderList = item.content//借款金额
              } else if (item.type == "bigList") {
                _this.bigList = item.content//产品列表
                _this.bigJson = item.head
              }
            })
          }
          else {
            _this.util.toast({ msg: e.msg })
          }
        })
        .catch(error => { });
    },
    getMsgCode () {//获取验证码
      //  else if (!(/(^\d{15}$)|(^\d{17}([0-9]|X)$)/.test(this.bankInfo.bankNum))) {
      //   //身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X。
      //   this.util.toast({ msg: '请填写正确的银行卡账户' });
      //   return false;
      // } 
      if (this.name.length <= 0) {
        this.util.toast({ msg: '请填写姓名' });
        return;
      } else if (this.phone.length <= 0 || !(/^1[3|4|5|6|7|8][0-9]\d{4,8}$/.test(this.phone))) {
        this.util.toast({ msg: '请填写正确的手机号码' });
        return;
      }
      let params = {
        mobilePhone: this.phone,
        bankCardNum: this.bankCardNum,
      }
      this.$get('/app/api/v1/bank/verifiycode', params).then(res => {
        if (res.code == 200) {
          this.cutdown();
        } else {
          this.util.toast({ msg: res.message, type: 'fail' })
        }
      });
    },
    cutdown () {//倒计时
      this.cutStart = true;
      if (this.second == 0) {
        this.cutStart = false;
        this.second = 59;
        return;
      } else {
        this.second = this.second - 1;
        setTimeout(() => {
          this.cutdown();
        }, 1000)
      }
    },
    sureRepay () {
      //确认还款
    }
  }

}
</script>
<style scoped>
.apply_box {
  background: #f7f7f7;
  padding-bottom: 0.2rem;
}
.bg {
  background: #f7f7f7;
  width: 100%;
  height: 0.1rem;
}
.header {
  padding: 0.85rem 0.41rem 0.3rem 0.41rem;
  /* margin-bottom: 0.1rem; */
  height: 2.3rem;
  width: 100%;
  background: url("../../assets/img/afterLoan/pay_bg.png") no-repeat top center;
  background-size: 100% 100%;
  margin: 0 auto;
  color: #fff;
  font-size: 0.12rem;
}
.loanMoney {
  font-size: 0.14rem;
  text-align: center;
}
.title {
  font-size: 0.3rem;
  text-align: center;
}
.pro_detail {
  background: #ffffff;
}
.pro_item {
  padding: 0.15rem;
  border-bottom: 1px solid #eee;
  display: flex;
  flex: 1;
  justify-content: space-between;
}

.replace_btn {
  color: #486cff;
  font-size: 0.14rem;
  padding: 0.15rem;
}

.pro_item1 {
  clear: both;
  overflow: hidden;
}
.inputStyle {
  padding: 0.15rem;
  width: 70%;
}
.pro_item .btn {
  color: #486cff;
  font-size: 0.14rem;
  text-align: center;
  margin: 0 auto;
  padding: 0.1rem;
}
.h1 {
  font-size: 0.16rem;
  color: #333;
}
.line {
  display: inline-block;
  width: 3px;
  height: 0.12rem;
  background: #486cff;
}
.info_box {
  font-size: 0.11rem;
  color: #333;
  padding: 0.1rem 0.15rem 0.36rem 0.15rem;
  background: #f7f7f7;
}
.info_box .agree {
  color: #486cff;
}

.look {
  color: #486cff;
  font-size: 0.13rem;
  float: right;
}
.loan_btn {
  color: #fff;
  background: linear-gradient(
    90deg,
    rgba(122, 157, 246, 1) 0%,
    rgba(81, 117, 241, 1) 100%
  );
  box-shadow: 0px 6px 10px 0px rgba(228, 238, 250, 1);
  border-radius: 25px;
  height: 0.5rem;
  line-height: 0.5rem;
  font-size: 0.17rem;
  text-align: center;
  line-height: 0.5rem;
  width: 90%;
  margin: 0 auto;
  margin-top: 0.4rem;
}
</style>
